<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage" src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage" src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm" *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']" class="kt-widget__item">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item kt-widget__item--active">
                                Eğitim Bilgilerim
                            </a>
                            <a [routerLink]="['/judge-form']" class="kt-widget__item">
                                Jürilik Bilgi Formu
                            </a>
                            <a [routerLink]="['/referee-form']" class="kt-widget__item">
                                Hakemlik Bilgi Formu
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">
                                    Eğitim Bilgileri
                                </h3>
                            </div>
                            <div class="kt-portlet__head-toolbar">
                                <div class="kt-portlet__head-actions">
                                    <a routerLink="/education-info/new" class="btn btn-success btn-pill btn-sm">
                                        <i class="fa fa-plus marr10"></i>Yeni Ekle
                                    </a>
                    
                                </div>
                            </div>
                        </div>
                        <form class="kt-form kt-form--label-right">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="row">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Okul</th>
                                                        <th>Bölüm/Departman</th>
                                                        <th>Öğrenim türü</th>
                                                        <th>Başlangıç tarihi</th>
                                                        <th>Bitiş tarihi</th>
                                                        <th>Durum</th>
                                                        <th>İşlemler</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let education of educationList;">
                                                        <td>{{ education.schoolName }}</td>
                                                        <td>{{ education.departmant}}</td>
                                                        <td>
                                                            {{ getEducationLevel(education.level)}}
                                                        </td>
                                                        <td>{{ education.startDate}}</td>
                                                        <td>{{ education.endDate}}</td>
                                                        <td>
                                                            {{ getStatus(education.isContinue)}}
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-success mr-2"
                                                                [routerLink]="['/education-info/detail/'+education.id]"><i
                                                                class="fa fa-edit"></i>Düzenle</button>
                                                            <button class="btn btn-danger mr-2" (click)="deleteEducationInfo(education.id)"><i
                                                                    class="fa fa-trash"></i>Sil</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>